// extracted by mini-css-extract-plugin
export default {"article":"article--BBGUb","title":"title--UNQrG","faqList":"faqList--fdJVs"};